/**
 * @description provides a context for sharing contract info with the rest of the page
 */

import React from 'react';
import { PropTypes } from 'prop-types';
import useContractInfo from '../hooks/useContractInfo';

export const ContractInfoContext = React.createContext(null);

export const ContractInfoProvider = ({ children }) => {
  const [contractInfo, setContractInfo] = React.useState(null);

  const { data } = useContractInfo();

  React.useEffect(() => {
    setContractInfo(data);
  }, [data]);

  return (
    <ContractInfoContext.Provider value={contractInfo}>
      {children}
    </ContractInfoContext.Provider>
  );
};

ContractInfoProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired
};
